export default __webpack_public_path__ + "static/ITCAvantGardeStd-Demi-2989b9fb063c29a369ec0d45a8734663.woff2";